import axios from 'axios';
import Cookies from 'js-cookie';

const { apiHost = '' } = window.chatwootConfig || {};
const wootAPI = axios.create({ baseURL: `${apiHost}/` });

const authHeaders = () => {
  const authCookie = Cookies.get('cw_d_session_info');
  if (!authCookie) return {};

  const {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  } = JSON.parse(authCookie);

  return {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  };
};

wootAPI.interceptors.request.use(config => {
  Object.assign(config.headers, authHeaders());
  return config;
});

export default wootAPI;
